import React from "react";

function AboutPage() {
  return (
    <div className="container mt-2">
      <h1>¡Bienvenidos a nuestra tienda!</h1>
      <p>
        En ella podrán encontrar las piezas disponibles para venta directa,
        podrán ver el stock del momento y ponerse en contacto con nosotros para
        coordinar la compra.
      </p>
      <p>¡Esperemos que les guste tanto como a nosotros!</p>
      <h2>Preguntas frecuentes</h2>
      <h3>¿Tienen local?</h3>
      <p>
        No por el momento, tenemos un taller en Tigre Centro, cerca del Puerto
        de Frutos por donde se pueden pasar a retirar los productos previamente
        elegidos a través de Instagram.
      </p>
      <h3>¿Hacen envíos?</h3>
      <p>
        Si, realizamos envíos a todo el país. El costo corre por cuenta del
        cliente.
      </p>
      <h3>¿Hacen venta mayorista?</h3>
      <p>
        Si, dependiendo de la demanda de pedidos que tengamos al momento de
        contactarnos variarán los tiempos de entrega.
      </p>
      <p>
        Para aquellos ansiosos que no pueden esperar podemos manejarnos con el
        stock disponible en ese momento y despachar los productos esa misma
        semana.
      </p>
      <h3>¿Cuál es la demora en la producción?</h3>
      <p>
        La demora en la realización de una pieza de cerámica tiene en cuenta
        muchos factores, uno importante es el clima, la humedad retrasa tooodo,
        también la cantidad de pedidos que tenemos en cola a la hora de tomar
        uno nuevo. Además depende de que productos y cuantos necesitan.
      </p>
      <p>
        En fin para no aburrir se debería calcular aprox 15/20 días hábiles en
        condiciones normales.
      </p>
      <h3>¿Se pueden personalizar las piezas?</h3>
      <p>Contáctanos para ver si podemos cumplir con tus expectativas!</p>
      <h3>¿Tienen compra mínima?</h3>
      <p>
        Para respetar el precio mayorista consideramos que el pedido debe ser de
        20 productos en adelante.
      </p>
      <h3>¿Medios de pago?</h3>
      <p>Efectivo, transferencia o mercado pago.</p>
    </div>
  );
}

export default AboutPage;
